export function convertToSeconds(value) {
    return value * 24 * 60 * 60;
}

export function convertHoursToSeconds(value) {
    return value * 3600;
}

export function convertToHours(seconds) {
    return Math.floor(seconds / 3600);
}

export function convertToDays(seconds) {
    return Math.floor(seconds / (3600 * 24));
}
